var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalInformacao",
      attrs: {
        titulo: _vm.tituloModalDespacho,
        width: _vm.width,
        isDespacho: true
      },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _vm.idProcesso
            ? _c("app-modal-selecionar-modelo-notificacao", {
                attrs: {
                  tiposModelo: _vm.tiposModelo,
                  titulo: "Modelos de Despacho",
                  idProcesso: _vm.idProcesso,
                  showModal: _vm.showModalDespacho
                },
                on: {
                  closeModal: _vm.fecharModalDespacho,
                  setTextoDespacho: _vm.setTextoDespacho
                }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "extra-margin-top" },
            [
              _c(
                "validation-observer",
                { ref: "validation", attrs: { tag: "form" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _c("app-label", {
                                staticClass: "mt-20",
                                attrs: { label: "Mensagem:", required: true }
                              }),
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn",
                                  attrs: { type: "primary" },
                                  on: { click: _vm.openModalDespacho }
                                },
                                [
                                  _c("span", { staticClass: "center" }, [
                                    _c("i", { staticClass: "fa fa-file icon" }),
                                    _c("b", [_vm._v("  Modelo")])
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("app-editor-texto", {
                                      ref: "editorTexto",
                                      staticClass: "input",
                                      class: { erro: errors.length },
                                      attrs: {
                                        value: _vm.despacho.textoDespacho
                                      },
                                      on: { onTextChange: _vm.onTextChange }
                                    }),
                                    errors.length
                                      ? _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-row", { staticClass: "margin-top" }, [
                    _c("p", { staticClass: "label mt-20" }, [
                      _vm._v("Anexos mensagem")
                    ])
                  ]),
                  _c(
                    "el-row",
                    { staticClass: "margin-top" },
                    [
                      _c("validation-provider", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-anexo", {
                                  attrs: {
                                    id: "upload-anexo-despacho",
                                    files: _vm.despacho.documentos.filter(
                                      function(doc) {
                                        return (
                                          doc.tipo.codigo === "ANEXO_ANALISE"
                                        )
                                      }
                                    ),
                                    scope: "anexos",
                                    errors: errors,
                                    exibirDownload: false
                                  },
                                  on: {
                                    removeFile: _vm.removeFile,
                                    uploadFile: _vm.uploadFile
                                  }
                                }),
                                _vm.isArquivamentoPresidencia &&
                                !_vm.isReurbIndividual
                                  ? _c(
                                      "el-card",
                                      [
                                        _c("app-label", {
                                          attrs: {
                                            label:
                                              "Inclua a Carta de Notificação ao Interessado",
                                            required: _vm.isValidateCarta !== ""
                                          }
                                        }),
                                        _c("validation-provider", {
                                          attrs: { rules: _vm.isValidateCarta },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("app-anexo", {
                                                      attrs: {
                                                        id:
                                                          "upload-carta-notificacao",
                                                        files: _vm.cartas,
                                                        showAnexar: true,
                                                        errors: errors,
                                                        tiposArquivosPermitidos:
                                                          _vm.tiposArquivosPermitidosMapas,
                                                        showUpload:
                                                          _vm.cartas.length ===
                                                          0
                                                      },
                                                      on: {
                                                        uploadFile:
                                                          _vm.uploadCartaNotificacao,
                                                        removeFile:
                                                          _vm.removeCartaNotificacao,
                                                        downloadDocumentoCadastro:
                                                          _vm.getDownload
                                                      },
                                                      model: {
                                                        value: _vm.cartas,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.cartas = $$v
                                                        },
                                                        expression: "cartas"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "default", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("b", [_vm._v("  Cancelar")])
                ])
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "success", size: "small" },
                on: {
                  click: function($event) {
                    return _vm.finalizarDespacho()
                  }
                }
              },
              [
                _c("span", { staticClass: "center" }, [
                  _c("i", { staticClass: "fa fa-share-square" }),
                  _c("b", [_vm._v("  Enviar")])
                ])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c0e416", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c0e416","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalDespachoPresidente.vue
// module id = null
// module chunks = 